import $ from 'jquery';
import _ from 'underscore';
import PubSub from 'pubsub-js';
var ScrollNav = function() {

  // Set up arrivals
    // self.globals.$navigationLinks = self.globals.$stickyNav.find('[data-nav-arrival]');
    // self.globals.$navigationLinks = $('[data-nav-arrival]');
    // self.globals.arrivalsAndDestinations = getArrivalsAndDestinations();
  // Was `this` (window) under Browserify; ES modules are strict, so `this` is undefined here
  var self = {};

	self.globals = {
		scrollTop: 0,
		$window: $(window),
    $next: $('.js-nav-next'),
    nextIsVisible: false,
    currentIndex: 0,
		$departures: [],
		$destinations: [],
    $activeDestination: [],
		departuresAndDestinations: []
	};

  self.defaults = {
    activeClass: 'is-active',
    departureDataString: 'nav-departure',
    destinationDataString: 'nav-destination',
  };

  function init(options){
  	var $window = $(window);
  	self.settings = $.extend( {}, self.defaults, options );

  	self.globals.$departures = $('[data-' + self.settings.departureDataString + ']');
  	self.globals.$destinations = $('[data-' + self.settings.destinationDataString + ']');
  	self.globals.departuresAndDestinations = getDeparturesAndDestinations();

  	// Set up arrivals
    // self.globals.$navigationLinks = self.globals.$stickyNav.find('[data-nav-arrival]');
    // self.globals.$navigationLinks = $('[data-nav-arrival]');
    // self.globals.arrivalsAndDestinations = getArrivalsAndDestinations();


  	// Add scroll event listeners
    // $window.scroll( $.throttle( 250, windowScrollHandler ) );
    $window.scroll( _.throttle( windowScrollHandler, 250 ) );

    // When scrolling is stopped, update the index.
    $window.scroll( _.debounce( windowDebounceHandler, 400));
    // $window.resize( $.debounce( 250, windowResizeHandler ) );

    // windowResizeHandler();
    windowScrollHandler();
    windowDebounceHandler();

    // Click Event Listeners
    self.globals.$departures.on('click', navItemClickHandler );

    self.globals.$next.on('click', function(e){
      e.preventDefault();

      var index = self.globals.currentIndex + 1,
          $destination = $(self.globals.$destinations[index]);
      scrollToDestination($destination);

      self.globals.currentIndex = index;
    });
  }

  function navItemClickHandler( e ){
    e.preventDefault();
    var $target = $(e.currentTarget),
        name = $target.data( self.settings.departureDataString ),
        navType = $target.data('nav-type'),
        $destination = $('[data-' + self.settings.destinationDataString + '=' + name + ']');

    scrollToDestination($destination, navType);

  }

  function scrollToDestination($destination, navType) {
    var destinationName = $destination.data(self.settings.destinationDataString);
    PubSub.publishSync('beforeScrollToDestination', destinationName);

    var $window = self.globals.$window,
        currentScrollTop = $window.scrollTop(),
        scrollDirection = -1,
        topPoint,
        topPadding = $window.height() * 0.05,
        middlePoint,
        scrollToPoint,
        mobileStartScroll,
        ease = Power2.easeInOut;

    // Set scroll Top
    topPoint = $destination.offset().top;
    scrollToPoint = topPoint - topPadding;

    if( $destination.outerHeight() > 1 && $destination.outerHeight() <= $window.height() ) {
      middlePoint = topPoint + ($destination.outerHeight() / 2) - ($window.height() / 2);
      scrollToPoint = middlePoint;
    }

    if ( ( scrollToPoint - currentScrollTop ) < 0 ) {
      scrollDirection = 1;
    }

    if( navType == 'mobile' ) {
      mobileStartScroll = scrollToPoint + ($window.height() / 2 * scrollDirection);
      $window.scrollTop( mobileStartScroll );
      ease = Power2.easeOut;
    }

    TweenMax.to( window, 1.5, {
      scrollTo: scrollToPoint,
      ease: ease,
      onComplete: scrollToComplete
    });

    function scrollToComplete(){
      PubSub.publish('afterScrollToDestination', destinationName);
    }
  }


  function windowScrollHandler( e ) {
    self.globals.scrollTop = self.globals.$window.scrollTop();
    updateDepartures( self.globals.scrollTop );
  }

  function windowDebounceHandler(e) {
    var $activeDestination = self.globals.$activeDestination,
        $destinations = self.globals.$destinations;
      if( $activeDestination.length < 1 ) return false;
      self.globals.currentIndex = $destinations.index( $activeDestination);
  }

  function updateDepartures( scrollTop ){
    var isActiveItem = false,
        destThreshold,
        windowHeight = self.globals.$window.height(),
        name,
        $dest;

    // Loop through destinations in their source order
    // TODO: Ideally you'd want to sort through them by their offset().top
    self.globals.$destinations.each(function(idx, dest){
      $dest = $(dest);
      destThreshold = $dest.offset().top - (windowHeight / 2); // subtract nav
      if( scrollTop >= destThreshold ){
        name = $dest.data( self.settings.destinationDataString );
        self.globals.$departures.removeClass( self.settings.activeClass );
        self.globals.$departures
            .filter('[data-' + self.settings.departureDataString + '="' + name + '"]')
            .addClass( self.settings.activeClass );
        isActiveItem = true;

        self.globals.$activeDestination = $dest;

        if( name !== 'home' && !self.globals.nextIsVisible ) {
          self.globals.nextIsVisible = true;
          self.globals.$next.addClass('is-active');
        }
      }
    });
  }

  //
  // Helpers
  //

  function getDeparturesAndDestinations() {
  	 var name,
         $departure,
         $dest;

    return self.globals.$departures.map(function(idx, $item) {
      $departure = $(this);
      name = $departure.data( self.settings.departureDataString );
      $dest = $('[data-' + self.settings.destinationDataString + '=' + name + ']');

      if( $dest.length > 0 ) {
        return {
          name: name,
          $departure: $departure,
          $dest: $dest
        };
      }
    });
  }



  init();

}

export default ScrollNav();